"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPath = getPath;
exports.stripPropertiesRecursive = stripPropertiesRecursive;
function getPath(obj, path) {
    const [prop, ...rest] = path.split(".");
    const sub = obj[prop];
    if (sub && typeof sub === "object" && rest.length) {
        return getPath(sub, rest.join("."));
    }
    else {
        return sub;
    }
}
function stripPropertiesRecursive(obj, properties) {
    for (const [key, value] of Object.entries(obj)) {
        if (properties.includes(key)) {
            delete obj[key];
            continue;
        }
        if (value && typeof value === "object" && !Array.isArray(value)) {
            stripPropertiesRecursive(value, properties);
        }
    }
    return obj;
}
//# sourceMappingURL=object.util.js.map